export function normalizeStatus(status) {
  return String(status || '').trim().toLowerCase();
}

export function isInactiveStatus(status) {
  return normalizeStatus(status) === 'inactive';
}

export function getInactiveAccountMessage(entity = 'Account') {
  return `Your ${entity.toLowerCase()} is disabled. Please contact the System Administrator for verification.`;
}

export function validateActiveAccount(docData, entity = 'Account') {
  if (isInactiveStatus(docData?.status)) {
    return {
      active: false,
      message: getInactiveAccountMessage(entity)
    };
  }
  return { active: true, message: null };
}
